import { render, staticRenderFns } from "./customer.vue?vue&type=template&id=617f1726&scoped=true"
import script from "./customer.vue?vue&type=script&lang=js"
export * from "./customer.vue?vue&type=script&lang=js"
import style0 from "./customer.vue?vue&type=style&index=0&id=617f1726&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "617f1726",
  null
  
)

export default component.exports